
export default {
  // Navigation-related translations
  "home": "홈",
  "profile": "프로필",
  "airports": "공항",
  "inventory": "인벤토리",
  "admin": "관리자",
  "resources": "자료",
  "develop": "현상",
  "sign_in": "로그인",
  "sign_up": "회원가입",
  // "light_meter": "노출계" // Commented out to hide from navigation
};
